// Import the functions you need from the SDKs you need
import { initializeApp } from 'firebase/app'
import { getAnalytics } from 'firebase/analytics'
import Vue from 'vue'
import { getMessaging, getToken } from 'firebase/messaging'
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: 'AIzaSyD6XtnqZtz7xNRZVJzhpOxzD7o1BwjdSAQ',
  authDomain: 'brcorte-aaab5.firebaseapp.com',
  projectId: 'brcorte-aaab5',
  storageBucket: 'brcorte-aaab5.appspot.com',
  messagingSenderId: '221772200436',
  appId: '1:221772200436:web:151a782784ad018844a1a1',
  measurementId: 'G-20HWVPSSRV'
}

// Initialize Firebase
export const app = initializeApp(firebaseConfig)

export const analytics = getAnalytics(app)
var title = 'Uma nova notificação do BR-Corte'
var body = 'Novas notificações estão disponíveis no BR-Corte!!!'
var icon = 'https://brcorte.com.br/favicon.png'
var tag = 'simple-push-demo-notification-tag'

let messaging = undefined
if (process.env.VUE_APP_PRODUCTION === true) {
  messaging = getMessaging(app)
  getToken(messaging, { messaging, vapidKey: 'BGhNkopE2S7Ph4XCXlIHJc39QqGyV5qPxuwZAjhBX8xCzl0CC0wt4rknERcBMvLhl5HsQzxNlP-9tXVfYVQjdMQ' }).then((currentToken) => {
    if (currentToken) {
      localStorage.setItem('clientToken', currentToken)
    } else {
      console.log('No registration token available. Request permission to generate one.')
    }
  }).catch((error) => {
    console.log('Error ao obter Token: ', error)
  })
  messaging.onMessageHandler = (payload) => {
    console.log('Message received. ', payload)

    if (payload.notification && 'serviceWorker' in navigator) {
      navigator.serviceWorker.getRegistration().then((registration) => {
        registration.showNotification(payload.notification.title ? payload.notification.title : title, {
          body: payload.notification.body ? payload.notification.body : body,
          icon: icon,
          vibrate: [200, 100, 200],
          title: payload.notification.title ? payload.notification.title : title
        })
      })
    }
  }
  const self = this
  messaging.onBackgroundMessageHandler = function (payload) {
    console.log(
      '[firebase-messaging-sw.js] Received background message ',
      payload
    )
    if (payload.notification && 'serviceWorker' in navigator) {
      navigator.serviceWorker.getRegistration().then((registration) => {
        registration.showNotification(payload.notification.title ? payload.notification.title : title, {
          body: payload.notification.body ? payload.notification.body : body,
          icon: icon,
          vibrate: [200, 100, 200],
          title: payload.notification.title ? payload.notification.title : title
        })
      })
    }
  }

  Vue.prototype.firebase = { app, analytics, messaging }
}
export default messaging
